import type { Menu } from '#/global'

const menus: Menu.recordRaw[] = [
  {
    meta: {
      title: '海报工具',
      icon: 'heroicons-solid:menu-alt-3',
    },
    path: '/tools/poster',
  },

]

export default menus
